import React, { useEffect, useState } from "react";
import {
  IconButton,
  Stack,
  Box,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
//Icons
import { MdModeEdit, MdOutlineDelete } from "react-icons/md";
import { BiDotsVerticalRounded } from "react-icons/bi";
import RemarkStuTransferAndPaidButNotCount from "./RemarkStuTransferAndPaidButNotCount"
import { useQuery } from "@apollo/client";
import { CHECK_IS_TRANSFER_OUT_AND_PAID } from "../../Schema/Enrollment";

export default function EnrollmentAction({

  editData,
  setRefetch,
}) {

  const [openRemarkStu, setOpenRemarkStu] = useState(false);
  const handleOpenRemarkStu = () => {
    setOpenRemarkStu(true);
  }
  const handleCloseRemarkStu = () => {
    setOpenRemarkStu(false);
  }


  const { refetch, data } = useQuery(CHECK_IS_TRANSFER_OUT_AND_PAID, {
    variables: {
      enrollmentId: editData?._id,
    },
  })

  useEffect(() => {
    refetch()
  }, [editData?._id])


  return (
    <div>
      <Stack direction="row" justifyContent="right">

        {
          data?.isTranferOutAndPaid &&

          <Tooltip title="" placement="top">
            <IconButton
              onClick={handleOpenRemarkStu}
              sx={{
                width: "40px"
              }}
            >
              <BiDotsVerticalRounded
                size="small"
              />
            </IconButton>
          </Tooltip>

        }


        <RemarkStuTransferAndPaidButNotCount
          open={openRemarkStu}
          handleClose={handleCloseRemarkStu}
          editData={editData}
          setRefetch={setRefetch}
        />

      </Stack>
    </div>
  );
}
